import { baseApi } from "./base";

export const notificationApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getNotifications: builder.query({
			query: () => "/notifications",
		}),
		addNotification: builder.mutation({
			query: (payload) => ({
				url: "/notifications",
				method: "POST",
				body: payload,
			}),
		}),
		readNotification: builder.mutation({
			query: (payload) => ({
				url: `/notifications/${payload.id}`,
				method: "PUT",
				body: payload,
			}),
		}),
		getUserLoadByMonthUser: builder.query({
			query: (query = null) => {
				return `/by-user-month${query ? query : ""}`;
			},
		}),
		getDashboardData: builder.query({
			query: () => "/dashboard-data",
		}),
		getDashboardBranchData: builder.query({
			query: () => "/branchs/dashaboard",
		}),
	}),
});

export const {
	useGetNotificationsQuery,
	useAddNotificationMutation,
	useReadNotificationMutation,
	useLazyGetUserLoadByMonthUserQuery,
	useGetDashboardDataQuery,
	useGetDashboardBranchDataQuery,
} = notificationApi;
